<template>
  <page :load="init">
    <v-layout row wrap>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
            </div>
            <v-spacer></v-spacer>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
          </v-card-title>
          <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="ipAddress" :loading="loading" :no-data-text="noDataText" :filter="customSearch" v-model="selected" select-all>
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td width="50px">
                <v-checkbox primary hide-details v-model="props.selected"></v-checkbox>
              </td>
              <td>{{ props.item.ipAddress }}</td>
              <td class="text-xs-right">{{ props.item.lastAttemptId }}</td>
              <td class="text-xs-right">{{ formatDateTime(props.item.unblockTime) }}</td>
            </template>
          </v-data-table>
        </v-card>
        <div class="pt-2">
          <v-btn color="primary" @click="doPromptUnblock" :loading="loading">
            Unblock Selected
            <v-icon right>mdi-minus-circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <confirm v-model="promptUnblock" @ok="doUnblock">
        Are you sure you want to unblock selected record(s)?
      </confirm>
    </v-layout>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import toDate from 'date-fns/toDate'

export default {
  data() {
    return {
      headers: [
        { text: 'IP Address', align: 'left', value: 'ipAddress' },
        { text: 'Last Attempt ID', align: 'right', value: 'lastAttemptId' },
        { text: 'Unblock time', align: 'right', value: 'unblockTime' }
      ],
      promptUnblock: false,
      menu: {}
    }
  },
  methods: {
    async init() {
      this.loading = true
      const apiUrl = this.$store.state.adminUser.security.menu.block
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((block) => {
              const convertBlock = {
                ipAddress: block.ipAddress,
                lastAttemptId: block.lastAttemptId,
                unblockTime: block.unblockTime ? toDate(block.unblockTime) : ''
              }
              this.items.push(convertBlock)
            })
            // Extract the menu
            this.menu = extractMenu(result.data._links)
          } else {
            this.items = []
          }
          this.loading = false
        } catch (error) {
          throw error
        }
      } else {
        throw new Error('Invalid API URL')
      }
    },
    doPromptUnblock() {
      if (this.selected.length > 0) {
        this.promptUnblock = true
      } else {
        this.warnMessage('Please select record(s) to be unblocked.')
      }
    },
    async doUnblock() {
      const apiURI = this.menu.unblock
      if (apiURI) {
        this.loading = true
        let postForm = []
        this.selected.map(select => {
          postForm.push(select.ipAddress)
        })
        try {
          const result = await this.$http.post(apiURI, postForm)
          this.message(result.data)

          // Reinit
          this.init()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
